import { Component, Mixins, Watch, Ref } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import Authentication from '@/views/Authentication/models/authentication'
import SignInUsernameInput from '@/views/Authentication/components/signInUsernameInput/signInUsernameInput.vue'
@Component({
    components: { SignInUsernameInput },
    mixins: [],
})
export default class Signin extends Mixins<MixinInterface>() {
    @Ref('form') readonly form!: HTMLFormElement

    loading = false
    valid = false

    signInUsername: any = ''
    password: any = null
    passwordVisible = false

    errorCode = ''

    get emailExistsOnOtherUser() {
        return this.$store.getters.emailExistsOnOtherUser
    }

    get mobileExistsOnOtherUser() {
        return this.$store.getters.mobileExistsOnOtherUser
    }

    @Watch('signInUsername')
    @Watch('password')
    resetInvalid() {
        this.errorCode = ''
    }

    async signIn() {
        this.valid = this.form.validate()

        if (this.valid && !this.loading) {
            this.loading = true
            let data = {
                type: 'session',
                attributes: {
                    signInUsername: this.sanitizeUsername(this.signInUsername),
                    signInPassword: this.password,
                },
            }

            let res = await Authentication.postSession(data).catch(() => {
                this.loading = false
            })

            if (typeof res == 'string') {
                this.errorCode = res
            }
            this.loading = false
        } else {
            for (const input of this.form.inputs) {
                if (!input.valid) {
                    input.focus()
                    break
                }
            }
        }
    }

    mounted() {
        if (this.emailExistsOnOtherUser) this.signInUsername = this.$store.getters.inputEmail
        if (this.mobileExistsOnOtherUser) this.signInUsername = this.$store.getters.inputMobile

        this.$nextTick(() => {
            if (this.signInUsername) {
                let password = this.$refs.password as HTMLFormElement
                password.$refs.input.focus()
            } else {
                let input = this.form.$el[0] as HTMLInputElement
                input.focus()
            }
        })
    }
}
